import React, { useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getEvaluation } from './evaluation.reducer';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const EvaluationDetail = (props: RouteComponentProps<{ ecoleid: string; anneeScolaireId: string; id: string }>) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getEvaluation(props.match.params.id));
  }, []);

  const evaluationEntity = useAppSelector(state => state.evaluation.entity);

  const goBack = () => props.history.goBack();
  return (
    <Row className="justify-content-center">
      <Col md="8">
        <h2 data-cy="evaluationDetailsHeading">
          <Translate contentKey="korischoolApp.evaluation.detail.title">Evaluation</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{evaluationEntity.id}</dd>
          <dt>
            <span id="titre">
              <Translate contentKey="korischoolApp.evaluation.titre">Titre</Translate>
            </span>
          </dt>
          <dd>{evaluationEntity.titre}</dd>
          <dt>
            <span id="numero">
              <Translate contentKey="korischoolApp.evaluation.numero">Numéro</Translate>
            </span>
          </dt>
          <dd>{evaluationEntity.numero}</dd>
          <dt>
            <span id="type">
              <Translate contentKey="korischoolApp.evaluation.type">Type</Translate>
            </span>
          </dt>
          <dd>{evaluationEntity.type}</dd>
          <dt>
            <span id="date">
              <Translate contentKey="korischoolApp.evaluation.date">Date</Translate>
            </span>
          </dt>
          <dd>{evaluationEntity.date}</dd>
          <dt>
            <span id="bareme">
              <Translate contentKey="korischoolApp.evaluation.bareme">Barème</Translate>
            </span>
          </dt>
          <dd>{evaluationEntity.bareme}</dd>
        </dl>
        <Button onClick={goBack} color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button
          tag={Link}
          to={`/evaluation/${evaluationEntity.ecoleId}/${props.match.params.anneeScolaireId}/${evaluationEntity.id}/edit`}
          replace
          color="primary"
        >
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default EvaluationDetail;
